import { render, staticRenderFns } from "./RangchaProductList.vue?vue&type=template&id=cff7f620&scoped=true"
import script from "./RangchaProductList.vue?vue&type=script&lang=js"
export * from "./RangchaProductList.vue?vue&type=script&lang=js"
import style0 from "./RangchaProductList.vue?vue&type=style&index=0&id=cff7f620&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff7f620",
  null
  
)

export default component.exports